import { __extends } from "tslib";
import * as React from 'react';
import { Icon } from '../icon/icon';
import { Text } from '../../new-libby/core/typography';
import { Tooltip } from '../tooltip/tooltip';
import { classNames } from '@wix/answers-lib';
import { namespacedClassnames } from '../../common';
export var multiToggleKey = 'multi-toggle';
var isIconToggleOptions = function (opts) {
    return !!(opts && opts[0]).icon;
};
var MultiToggle = /** @class */ (function (_super) {
    __extends(MultiToggle, _super);
    function MultiToggle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggle = function (index) { return function () {
            var props = _this.props;
            var selected = props.options[index].value;
            if (!_this.props.disabled && !props.options[index].disabled) {
                _this.props.onChange(selected);
            }
        }; };
        _this.getClasses = function (index, value, isIcon) { return classNames('toggle-btn', {
            selected: _this.props.value === value,
            first: index === 0,
            last: index === _this.props.options.length - 1,
            'all-disabled': !!_this.props.disabled,
            disabled: _this.props.options[index].disabled,
            'is-icon': isIcon
        }); };
        _this.getButtons = function () {
            var props = _this.props;
            var options = props.options;
            if (isIconToggleOptions(options)) {
                return options.map(function (option, index) {
                    var isIcon = true;
                    var selected = _this.props.value === option.value;
                    var className = _this.getClasses(index, option.value, isIcon);
                    return (React.createElement(Tooltip, { className: selected ? 'selected' : '', body: option.disabled || option.description || '', key: option.value },
                        React.createElement("div", { className: className, onClick: _this.toggle(index) },
                            React.createElement(Icon, { icon: option.icon }))));
                });
            }
            return options.map(function (option, index) {
                var isIcon = false;
                var selected = _this.props.value === option.value;
                var className = _this.getClasses(index, option.value, isIcon);
                return (React.createElement(Tooltip, { className: selected ? 'selected' : '', body: option.disabled || '', key: option.value, forceHidden: !option.disabled },
                    React.createElement("div", { className: className, onClick: _this.toggle(index), key: option.value },
                        React.createElement(Text, { type: 'ht', color: 't60' }, option.label))));
            });
        };
        return _this;
    }
    MultiToggle.prototype.render = function () {
        return (React.createElement("div", { className: namespacedClassnames(multiToggleKey) }, this.getButtons()));
    };
    return MultiToggle;
}(React.PureComponent));
export { MultiToggle };
//# sourceMappingURL=index.js.map